import React, { useEffect } from 'react';
import { CookiesProvider } from 'react-cookie';
import {
  // HashRouter
  BrowserRouter as Router,
  useLocation,
} from 'react-router-dom';

import '~/global.css';
import '~/localization';

import Routes from '~/routes';
import AppProvider from '~/hooks';
import { useAnalytics } from '~/hooks/analytics';

const AppWithAnalytics: React.FC = () => {
  const location = useLocation();
  const { logPageView } = useAnalytics();

  useEffect(() => {
    // Rastrear mudanças de página
    const pathName = location.pathname;
    const pageName = pathName === '/' ? 'home' : pathName.replace('/', '');
    logPageView(pageName);
  }, [location, logPageView]);

  return <Routes />;
};

const App: React.FC = () => (
  <Router>
    <CookiesProvider>
      <AppProvider>
        <AppWithAnalytics />
      </AppProvider>
    </CookiesProvider>
  </Router>
);

export default App;
